/*
 * Shows 3 (default) random items from a feed if div-container around feed has class .feed-random
 * If has class .two-column-feed also, it selects 2 random items instead
 * 
 * Experimental: FeedRandom(true). Uses JS crypto API which is more random than Math.random() at
 * close to no performance loss for e.g. 3 numbers (0-1ms)
 */

export default function FeedRandom(moreRandom) {
  const feedRandom = document.querySelector(".feed-random");
  if(!feedRandom) return;

  const feedRandomElms = feedRandom.querySelectorAll("li");
  if(!feedRandomElms) return;

  let randomNumbersCount = 3; // default
  if(feedRandom.classList.contains("two-column-feed")) {
    randomNumbersCount = 2;
  }
  
  const max = feedRandomElms.length;
  const min = 1;

  const randomNumbers = {};
  while(Object.keys(randomNumbers).length < randomNumbersCount) {
    let rng = 0;

    if(typeof moreRandom === "boolean" && moreRandom) {
      // Uses CSRNG (less predictable)
      // https://stackoverflow.com/questions/18230217/javascript-generate-a-random-number-within-a-range-using-crypto-getrandomvalues
      const randomBuffer = new Uint32Array(1);
      window.crypto.getRandomValues(randomBuffer);
      rng = randomBuffer[0] / (0xffffffff + 1);
    } else {
      // Uses standard PRNG (XorShift128+)
      rng = Math.random();
    }
    const randomNumber = Math.floor(rng * (max - min + min)) + min;
    if(!randomNumbers["" + randomNumber]) {
      randomNumbers["" + randomNumber] = "Unique random number";
      feedRandom.querySelector("li.item-" + randomNumber).classList.add("random-elm");
    }
  }
}